import styled, { css } from 'styled-components';
import colors from '../../styles/colors';

interface CamProps {
  mobile: boolean;
}

export const UploadSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 320px;
  width: 400px;
  position: relative;

  @media (max-width: 600px) {
    width: 100%;
    height: 240px;
  }

  video {
    min-height: 300px;
    width: auto;
    background: #ccc;
  }

  button {
    border: 0;
    background: ${colors.aux2};
    padding: 0.5rem;
    color: #fff;
    width: fit-content;
    border-radius: 8px;
    align-self: center;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);
    transition: filter 0.3s;

    &:hover {
      filter: brightness(0.9);
      color: #fff;
    }
  }
`;

export const Actions = styled.div<CamProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  button {
    margin: 0 0.5rem;

    ${props =>
      props.mobile &&
      css`
        margin: 0.5rem;
      `}
  }
`;
